module.exports = __webpack_public_path__ + "img/fast_v2.5fe2bc8.png";